import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import '../../../components_style/doctorComponents/FormsStyle.css'
import * as Yup from "yup";
import LeumitSelfPatientDetails from "../../../components/Leumit_Patient_SelfOnboard/LeumitSelfPatientDetails";
import LeumitSelfContactDetails from "../../../components/Leumit_Patient_SelfOnboard/LeumitSelfContactDetails";
import LeumitSelfLifestyle from "../../../components/Leumit_Patient_SelfOnboard/LeumitSelfLifestyle";
import FormElementContainerResponsive from "../../../components/forms_builder/FormElementContainerResponsive";


class PainSelfMedicalInfoTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
            errors: this.props.errors,
            tabInternalView: 1,
            docWidth: document.body.offsetWidth,
        };
    }

    componentDidMount() {
        const self = this;
        window.addEventListener('resize', function () {
            self.setState({docWidth: document.body.offsetWidth})
        }, true);

    }

    onValueChange = (name, value) => {
        this.props.onValueChange(name, value)
    }
    addPsychiatricForm = (value) => {
        this.props.addPsychiatricForm(value)
    }

    onYesNoValueChange = (name, value) => {
        this.props.onYesNoValueChange(name, value)
    }
    getPatientAge = (birthday) => {
        this.props.getPatientAge(birthday)
    }
    changeView = (view) => {
        this.props.changeView(view)
    }

    changeTabInternalView = (view) => {
        let viewToChange = view === this.state.tabInternalView ? 0 : view
        this.setState({tabInternalView: viewToChange})
        let elmntToView = document.getElementById('patientsFormBoxes-title-text');
        if (elmntToView){
            elmntToView.scrollIntoView();

        }
    }

    render() {
        let {t} = this.props
        let {docWidth} = this.state

        return (
            <div className={'patientForm-box-container'}>
                <FormElementContainerResponsive title={t('patient_self_boarding.personal_details')}
                                                Component={LeumitSelfPatientDetails}
                                                tabInternalView={this.state.tabInternalView}
                                                currentContainerView={1}
                                                docWidth={docWidth}
                                                changeTabInternalView={(view) => this.changeTabInternalView(view)}
                                                rest={{
                                                    onValueChange: (name, value) => this.onValueChange(name, value),
                                                    addPsychiatricForm: (value) => this.addPsychiatricForm(value),
                                                    getPatientAge: (birthday) => this.getPatientAge(birthday),
                                                    changeTabInternalView: (view) => this.changeTabInternalView(view),
                                                    docWidth: docWidth,
                                                    entry: this.props.entry,
                                                    errors: this.props.errors,
                                                    t: (e) => this.props.t(e),
                                                    onYesNoValueChange: (name, value) => this.onYesNoValueChange(name, value),
                                                }}/>

                <FormElementContainerResponsive title={t('patient_self_boarding.ContactDetails')}
                                                Component={LeumitSelfContactDetails}
                                                tabInternalView={this.state.tabInternalView}
                                                currentContainerView={2}
                                                docWidth={docWidth}
                                                changeTabInternalView={(view) => this.changeTabInternalView(view)}
                                                rest={{
                                                    onValueChange: (name, value) => this.onValueChange(name, value),
                                                    onYesNoValueChange: (name, value) => this.onYesNoValueChange(name, value),
                                                    changeTabInternalView: (view) => this.changeTabInternalView(view),
                                                    docWidth: docWidth,
                                                    entry: this.props.entry,
                                                    cityList: this.props.cityList,
                                                    israelCities: this.props.israelCities,
                                                    t: (e) => this.props.t(e),
                                                    errors: this.props.errors,
                                                }}/>


                <FormElementContainerResponsive title={t('patient_self_boarding.Lifestyle')}
                                                Component={LeumitSelfLifestyle}
                                                tabInternalView={this.state.tabInternalView}
                                                currentContainerView={3}
                                                docWidth={docWidth}
                                                changeTabInternalView={(view) => this.changeTabInternalView(view)}
                                                rest={{
                                                    onValueChange: (name, value) => this.onValueChange(name, value),
                                                    onYesNoValueChange: (name, value) => this.onYesNoValueChange(name, value),
                                                    changeView: (view) => this.changeView(view),
                                                    docWidth: docWidth,
                                                    entry: this.props.entry,
                                                    errors: this.props.errors,
                                                    t: (e) => this.props.t(e),
                                                }}/>

                <div className={'blankSpace'}/>

            </div>
        );
    }
}


const PainSelfPersonalDetailsTab = compose(
    withTranslation(),
)(PainSelfMedicalInfoTabComposed);

export default PainSelfPersonalDetailsTab;
